import { axiosStudentInstance } from "./studentAuth"
import type { StudentApiEnvelope } from "./studentQuestions"
import type { StudentNote } from "../page/Student/Notes/types"

export type { StudentNote }

export interface StudentNoteCreatePayload {
  title: string
  content: string
  subject: string
  color: StudentNote["color"]
}

export const listStudentNotes = (page_number = 1, per_page = 12) =>
  axiosStudentInstance.get<StudentApiEnvelope<StudentNote[]>>("/notes/", {
    params: { page_number, per_page },
  })

export const createStudentNote = (payload: StudentNoteCreatePayload) =>
  axiosStudentInstance.post<StudentApiEnvelope<StudentNote>>("/notes/", payload)

export const updateStudentNote = (
  noteId: string,
  payload: StudentNoteCreatePayload
) =>
  axiosStudentInstance.put<StudentApiEnvelope<StudentNote>>(
    `/notes/${noteId}/`,
    payload
  )

export const deleteStudentNote = (noteId: string) =>
  axiosStudentInstance.delete<StudentApiEnvelope<{ id: string }>>(
    `/notes/${noteId}/`
  )
